import React from "react";
import ReactApexChart from "react-apexcharts";
import "./MerchantDashboard.css";

function PayinChart({ payInStatistic }) {
  const successful = payInStatistic?.payIn?.payinSucessfull
    ? payInStatistic?.payIn?.payinSucessfull
    : 0;
  const failed = payInStatistic?.payIn?.payinFailed
  
    ? payInStatistic?.payIn?.payinFailed
    
    : 0;
  const pending =
  payInStatistic?.payIn?.payinPending
  ?  payInStatistic?.payIn?.payinPending  : 0
  

  const totalTransactions = payInStatistic?.payIn?.payInTotal
  
    ? payInStatistic?.payIn?.payInTotal
    
    : 0;

  const data = [
    {
      id: 1,
      name: "Successful",
      percentValues: (successful / totalTransactions) * 100,
      color: "#00C49F",
      count: successful,
    },
    {
      id: 2,
      name: "Pending",
      percentValues: (pending / totalTransactions) * 100,
      color: "#F7B924",
      count: pending,
    },
    {
      id: 3,
      name: "Failed",
      percentValues: (failed / totalTransactions) * 100,
      color: "#FF8042",
      count: failed,
    },
  ];
  const series = [successful, pending, failed];

  const options = {
    chart: {
      height: 200, // Set desired height
      width: 200, // Set desired width
      type: "pie",
    },
    legend: {
      show: false,
      position: "bottom",
    },
    labels: ["Successful", "Pending", "Failed"],
    colors: ["#00C49F", "#F7B924", "#FF8042"], // Set colors for each category
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <div>
      <div className="main-box">
        <div>
          <p className="heading-new">TOTAL DEPOSITS</p>
          <p className="merchant-users-1 sub-heading-new">
            {payInStatistic ? payInStatistic?.payIn?.payInTotal : 0}
          </p>
        </div>

        <div>
          <div className="sucess-rate-1">
            <p>Success Rate:</p>
            <p>
              {successful == 0
                ? "0.00"
                : ((successful / totalTransactions) * 100).toFixed(2)}
              %
            </p>
          </div>
        </div>
      </div>

      <div className="trans-pie-mer">
        {payInStatistic && (
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="pie"
              height={200} // Ensure the chart renders with the specified height
              width={200} // Ensure the chart renders with the specified width
            />

           
          </div>
        )}


<div className="data-rate">
              {data.map((category) => (
                <div key={category.id} className="progress-card-category">
                  <p
                    className="square-box"
                    style={{
                      backgroundColor: `${category.color}`,
                    }}
                  ></p>

                  <p className="category-value">
                    {category.name}: {category.count}
                  </p>
                </div>
              ))}
            </div>

        <div id="html-dist"></div>
      </div>
    </div>
  );
}

export default PayinChart;
